import { CARE_DASHBOARD_STATUS_PATH, DEPRECATED_CARE_DASHBOARD_STATUS_PATH } from 'ui/Care/paths';

// ReactRouter Redirects using `from` prop only works for `Switch` children.
// See https://reacttraining.com/react-router/web/api/Redirect/from-string
// Intended to be rendered inside AppRoutes.
export const REDIRECT_PATHS = [
  {
    fromPaths: [DEPRECATED_CARE_DASHBOARD_STATUS_PATH],
    to: CARE_DASHBOARD_STATUS_PATH,
  },
];
